import { styled } from "@mui/material";
import { ReactNode, useEffect } from "react";
import { Helmet } from "react-helmet-async";
import UserAccountMenu from "../../features/auth/component/user-account-menu";
import ListSearchBar from "../../features/list-search";
import { IWithClassName, IWithThemeProps } from "../../theme/default.theme";
import Footer from "./footer";
import ProductDropdown from "./product-dropdown";
import Sidebar from "./sidebar";

interface IOwnProps {
    children: ReactNode;
    pageTitle: string;
}

const CONTENT_WIDTH = 1150;

const PageTemplate = ({
    children,
    pageTitle,
    className,
}: IOwnProps & IWithClassName) => {
    useEffect(() => {
        window.scroll(0, 0);
    }, []);

    return (
        <div className={className}>
            <Helmet>
                <title>{pageTitle}</title>
            </Helmet>
            <aside>
                <Sidebar />
            </aside>
            <div className="centered-content">
                <div className="header-container">
                    <div className="header-content">
                        <header className="header">
                            <ProductDropdown />
                            <ListSearchBar />
                            <UserAccountMenu />
                        </header>
                    </div>
                </div>
                <div className="content-box">
                    <main>{children}</main>
                </div>
                <div className="footer-container">
                    <footer>
                        <Footer />
                    </footer>
                </div>
            </div>
        </div>
    );
};

export default styled(PageTemplate)(({ theme }: IWithThemeProps) => ({
    display: "flex",
    flexGrow: 1,
    margin: 0,
    padding: 0,
    ".centered-content": {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        flexGrow: 1,
        backgroundImage: "url(/assets/poi-grid.svg)",
    },
    ".content-box": {
        width: CONTENT_WIDTH,
        paddingLeft: theme?.spacing(10),
        paddingRight: theme?.spacing(10),
        paddingTop: theme?.spacing(9),
        boxSizing: "border-box",
        flexGrow: 1,
    },
    ".header": {
        display: "flex",
        justifyContent: "flex-end",
    },
    ".header-container": {
        position: "sticky",
        top: -40,
        zIndex: 1000,
        width: "100%",
        backgroundColor: theme?.palette.background.default,
    },
    ".header-content": {
        width: CONTENT_WIDTH,
        paddingLeft: theme?.spacing(10),
        paddingRight: theme?.spacing(10),
        boxSizing: "border-box",
        margin: "0 auto",
    },
    ".footer-container": {
        flexGrow: 0,
        footer: {
            width: CONTENT_WIDTH,
            paddingLeft: theme?.spacing(10),
            paddingRight: theme?.spacing(10),
            paddingTop: theme?.spacing(4),
            boxSizing: "border-box",
            margin: "0 auto",
        },
    },
}));
